import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
} from "react-router-dom";
import { auth, firebaseInitialized } from "./firebase"; // Import the Firebase auth object
import { UserProvider } from "./contexts/UserContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { SettingsProvider } from "./contexts/SettingsContext";
import { useTranslation } from "react-i18next";
import MenuBar from "./menuBar";
import Footer from "./components/Footer";
import Login from "./login";
import Home from "./home";
import SuccessPage from "./pages/SuccessPage";
import CancelPage from "./pages/CancelPage";
import Signup from "./pages/Signup";
import ForgotPassword from "./pages/ForgotPassword";
import EmailVerification from "./pages/EmailVerification";
import TermsOfService from "./pages/TermsOfService";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Settings from "./pages/Settings";
// import Subscription from "./pages/Subscription";
import OAuthAuthorize from "./pages/OAuthAuthorize";
import UnsubscribePage from "./pages/UnsubscribePage";
import Blog from "./pages/Blog";
import BlogArticle from "./pages/BlogArticle";
import { Spinner, Alert, Container } from "react-bootstrap";

function App() {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!firebaseInitialized || !auth) {
      setLoading(false);
      return;
    }

    const unsubscribe = auth.onAuthStateChanged(() => {
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  // Show error if Firebase is not initialized
  if (!firebaseInitialized || !auth) {
    return (
      <Container className="mt-5">
        <Alert variant="danger">
          <Alert.Heading>{t('errors.configurationError')}</Alert.Heading>
          <p>
            {t('errors.firebaseNotConfigured')}
          </p>
          <p className="mb-0">
            <small>
              {t('errors.firebaseConfigError')}
            </small>
          </p>
        </Alert>
      </Container>
    );
  }

  if (loading) {
    return (
      <Container className="mt-5 text-center">
        <Spinner animation="border" />
      </Container>
    );
  }

  return (
    <ThemeProvider>
      <SettingsProvider>
        <UserProvider>
          <Router>
            <MenuBar />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/verify-email" element={<EmailVerification />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/success" element={<SuccessPage />} />
              <Route path="/cancel" element={<CancelPage />} />
              <Route path="/terms" element={<TermsOfService />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/oauth/authorize" element={<OAuthAuthorize />} />
              <Route path="/unsubscribe" element={<UnsubscribePage />} />
              <Route path="/blog" element={<BlogArticle />} />
              <Route path="/blog/:slug" element={<Blog />} />
            {/* {user ? (
              <>
                <Route path="/subscription" element={<Subscription />} />
              </>
            ) : (
              <></>
            )} */}
          </Routes>
          <Footer />
        </Router>
      </UserProvider>
      </SettingsProvider>
    </ThemeProvider>
  );
}

export default App;
